import React, { useState } from 'react';
import './App.css';
import Menu from './components/Menu';
import { Container, Row, Col, Navbar, NavbarToggler, NavbarBrand, Alert, Button } from 'reactstrap';
import helpers from "./helpers/Utilities";

function Inicio() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const nome = JSON.parse(localStorage.getItem('usuario_logado')).nome;
    const expirado = (localStorage.getItem('usuario_expirado') === "S");

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Bem-vindo à FIKM</NavbarBrand>
                </Navbar>
                <Container>
                    <Row>
                        { expirado && 
                        <Col className="mt-3">
                            <Alert color="danger">
                                Sua anuidade está vencida. Por favor faça o pagamento para ter acesso a todos os recursos dos associados.
                            </Alert>
                        </Col>
                        }
                    </Row>
                    <Row>
                        <Col className="text-center pt-3">
                            <img src="logo2.png" alt="Logo FIKM" style={{'width': '40%'}}></img>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-center pt-3">
                            <h3 className="txt-azul">{nome}</h3>
                        </Col>
                    </Row>
                    { expirado &&
                    <Row>
                        <Col className="text-center pt-4">
                            <Button onClick={() => helpers.externalLink('https://pag.ae/7V-p6-Tpu')} className="btn btn-lg btn-primary btn-azul">Pagar Anuidade</Button>
                        </Col>
                    </Row>
                    }
                </Container>
            </div>
        </div>
    );
}

export default Inicio;
